import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useFavorites } from "@/lib/favorites";
import { toast } from "sonner";

export default function FavoriteButton({ answer }) {
  const { isFavorite, toggle } = useFavorites();
  const fav = isFavorite(answer.id);

  const onClick = () => {
    toggle({
      id: answer.id,
      title: answer.title,
      question: answer.question,
      image_url: answer.image_url,
    });
    toast.success(fav ? "Removed from favorites" : "Saved to your favorites");
  };

  return (
    <Button
      data-testid="favorite-button"
      onClick={onClick}
      variant={fav ? "default" : "outline"}
      className="rounded-full font-sans"
    >
      <Heart className={`mr-2 h-4 w-4 ${fav ? "fill-current" : ""}`} />
      {fav ? "Saved" : "Save"}
    </Button>
  );
}
